import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment';
import * as Yup from 'yup'

function ObservationsurveillanceTwo() {
    const history = useHistory();
    const { orgcode } = useParams()
    const [leadauditorList, setLeadauditorList] = useState([{
        label: "",
        value: ""
    }])
    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        address: "",
        siteofaddress: 'NA',
        effectiveNoEmpToBeAudited: "",
        mobile: "",
        email: "",
        scope: "",
        nabcbcodeName: "",
        contactPersonName: "",
        dateofaudit: "",
        auditteam: "",
        purpose: "",
        businesssector: "",
        teamleaderName: "",
        accompanyingteam: "",
        purspose: "",
        significantchanges: "",
        technicalexpertName: "",
        datestage2observation: "",
        placeofaudit: "",
        anydeviationinauditplan: "",
        briefaboutorg: "",
        anysignificantissue: "",
        anyunresolved: "",
        criteriaofaudit: "",
        objectiveofaudit: "",
        verificationofeffectiveness: "",
        externalissues: "",
        internalissues: "",
        needsandexpectations: "",
        riskandopportunity: "",
        auditorcomments1: "",
        leadership: "",
        customerfocus: "",
        qualitypolicy: "",
        organizationalroles: "",
        auditorcomments2: "",
        customercommunication: "",
        determiningofrequirements: "",
        reviewofrequirements: "",
        changestorequirements: "",
        customersatisfaction: "",
        resources: "",
        competence: "",
        awareness: "",
        internalandexternal: "",
        auditorcomment3: "",
        environmentoperation: "",
        controlofproduction: "",
        identification: "",
        propertybelonging: "",
        postdelivery: "",
        controlofchanges: "",
        releaseofproduct: "",
        controlofnonconforming: "",
        measurementtraceability: "",
        auditorcomments4: "",
        controlofexternally: "",
        typeofextent: "",
        outsourceprocess: "",
        informationforexternal: "",
        preservation: "",
        monitoring: "",
        internalauditDes: "",
        managementreview: "",
        nonconformity: "",
        continualimprovement: "",
        auditorcomments5: "",
        obervations: "",
        opportunitiesforimprovment: "",
        positivefindingsSurveillance: "",
        gpPvtHealthSubCenterOptions: "Yes",
        typeofaudit: "Initial Audit",
        Auditor: "",
        designanddevelopment: "",
        fileno: "",
        reportno: "",
        anychangessincelastaudit: "",
        verificationofcertification: "",
        improvementmade: "",
        purpose: "",
    })
    const gpPvtHealthSubCenterOptions = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
    ]

    const typeofaudit = [
        { key: 'Initial Audit ', value: 'Initial Audit' },
        { key: 'Special Audit', value: 'Special Audit' }
    ]



    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/stagetwo/get/stagetwocompanylistbyroleforsurvillance/' + localStorage.getItem("userCode"), {}))


    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })

    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/survillanceTwo/get/surveillancetwodata/' + params, {}), {
        onSuccess(data) {
            console.log("dat in mutation  sur2 orgCode",data.data.response.orgCode)
            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                tempInitialValues.orgCode = data.data.response.orgCode
                tempInitialValues.address = data.data.response.address || "";
                tempInitialValues.effectiveNoEmpToBeAudited = data.data.response.effectiveNoEmpToBeAudited || "";
                tempInitialValues.email = data.data.response.email || "";
                tempInitialValues.contactPersonName = data.data.response.contactPersonName || "";
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;

                tempInitialValues.datestage2observation = Date.parse(data.data.response.datestage2observation) || null;
                tempInitialValues.auditteam = data.data.response.auditteam || "";
                tempInitialValues.mobile = data.data.response.mobile || "";
                tempInitialValues.placeofaudit = data.data.response.placeofaudit || "";
                tempInitialValues.significantchanges = data.data.response.significantchanges || "";
                tempInitialValues.positivefindingsSurveillance = data.data.response.positivefindingsSurveillance || "";
                tempInitialValues.nabcbcodeName = data.data.response.nabcbcodeName || "";
                tempInitialValues.typeofaudit = data.data.response.typeofaudit || "Initial Audit";
                tempInitialValues.siteofaddress = data.data.response.siteofaddress || "NA";
                tempInitialValues.purpose = data.data.response.purpose || "";
                tempInitialValues.externalissues =data.data.response.externalissues|| ""
                // if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                //     mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                // }

                // tempInitialValues.scopeofcertification = data.data.response.scope || "";
                setInitialValues(tempInitialValues)
            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })

    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values sur 2", values)
        mutation.mutate(values)
    }


    const mutation = useMutation((params) => Fetcher('patch', '/api/survillanceTwo/patch/surveillancetwoobservationdetails', params), {
        onSuccess(data) {
            console.log("localStorage.getItem", localStorage.getItem("role"))
            if (data.data.errorCode === 0) {
                ToastInstance('Success', ' Surveillance Two Observation  Data Filled')
                window.location.href = "/"+localStorage.getItem("role")+"/view/surveillancetwoobservation/" + data.data.response.orgCode
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const { data: Rfqdata, isLoading } = useQuery(
        'listrfq',
        () => { if(orgcode) return Fetcher('get', '/api/survillanceTwo/get/surveillancetwodata/' + orgcode, {})})

    useEffect(() => {
        if (Rfqdata && initialValues.orgCode === 0) {
            var tempData = Rfqdata.data.response
            console.log("tempData", tempData)
            tempData.dateofaudit = Date.parse(tempData.dateofaudit);
            tempData.datesur = Date.parse(tempData.datesur);
            tempData.duedate = Date.parse(tempData.duedate);
            tempData.datestage2observation = Date.parse(tempData.datestage2observation)
            setInitialValues(tempData)
            // if (tempData.nabcbcode && tempData.nabcbcode !== "") {
            //     mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
            // }


        }
    }, [orgcode && !isLoading && initialValues.orgCode === 0])
    if (companyListLoading) return <h1>Loading</h1>

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                // validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {
                    formik => <Form>
                        <div className="content-wrapper">
                            <section className="content">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-sm-12">
                                                        <form>
                                                            <div className="formOuterDiv">
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='fileno' label='File No' />
                                                                    <FormikControl control='input' type="text" name='reportno' label='Report No' />

                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response} onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} label='Organization' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='address' label='Address' className="form-control" disabled={true} />
                                                                </div>

                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='siteofaddress' label='Site Address (If any)' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='effectiveNoEmpToBeAudited' label='No. of Employees' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='email' label='Email id' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='contactPersonName' label='Contact Person' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type="text" name='mobile' label='Mobile/Fax' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='nabcbcodeName' label='ANZSIC Code / NACE CODE' disabled={true} />

                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='scope' disabled={true} label='Scope' className="form-control" />
                                                                </div>
                                                                <div className="row mt-3" style={{ marginLeft: "0.5%" }}>
                                                                    <div className="col-sm-7 text-dark">
                                                                        <label>Non applicable requirements as determined by organisation: </label>
                                                                    </div>
                                                                    <div className="col-sm-5">
                                                                        <p>All Clauses are applicable</p>
                                                                    </div>

                                                                    <div className="row mt-2">
                                                                        <div className="row">
                                                                            <label htmlFor="staticEmail" className="col-sm-6">Justification for Non applicability checked and accepted?</label>
                                                                            <div className="col-sm-6">
                                                                                <FormikControl control='radio' name='gpPvtHealthSubCenterOptions' options={gpPvtHealthSubCenterOptions} />

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row mt-3">
                                                                        <div className="row">
                                                                            <label htmlFor="staticEmail" className="col-sm-6">Type Of Audit</label>
                                                                            <div className="col-sm-6">
                                                                                <FormikControl control='radio' name='typeofaudit' options={typeofaudit} />
                                                                            </div>

                                                                        </div>
                                                                        <p className="mt-4"><b>Note: </b><i>Combined/Joint/integrated audit(If Applicable) </i></p>
                                                                    </div>
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='significantchanges' label='Significant Changes(if any),Since last audit that affects QMS' disabled={true} />
                                                                </div>

                                                                <div className="hrstyle">
                                                                    <h5>Audit Team</h5>
                                                                </div>

                                                                <div className="form2RowDiv">
                                                                    {/* <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`, e.value)
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                                disabled={true} /> */}

                                                                    <FormikControl control='input' type='text' label='Team Leader/ Lead Auditor' name='teamleaderName' disabled={true} />

                                                                    <FormikControl control='input' type='text' label='Technical expert' name='technicalExpertName' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='input' type='text' label='Auditor' name='auditorOneName' disabled={true} />

                                                                </div>
                                                                <div className="form2RowDiv">
                                                                    <FormikControl control='date' dateFormat="dd-MM-yyyy" name='datestage2observation' className="form-control" label='Audit Observation Date' disabled={true} />
                                                                    <FormikControl control='input' type="text" name='purpose' label='Purpose of Audit' disabled={true} />

                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='anychangessincelastaudit' label='Any Changes Since Last Audit (Name, Address, Scope, Site etc.)' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='verificationofcertification' label='Verification of use of Certification Mark and Logo' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='improvementmade' label='Improvement Made in Last One Year' />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='anydeviationinauditplan' label='Any Deviation in the Audit Plan and Reason(if any)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='briefaboutorg' label='Brief about the organization' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='anysignificantissue' label='Any Significant issue impacting on the Audit Programme' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='anyunresolved' label='Any unresolved issues(if identified)' disabled={true} />
                                                                </div>

                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='criteriaofaudit' label='Criteria of Audit(Disclaimer Statement)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='objectiveofaudit' label='Objective of Audit' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='verificationofeffectiveness' label='Verification of effectiveness of NC closure of Stage 1 Audit(If any)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='externalissues' label='External Issues' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='internalissues' label='Internal Issues' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='needsandexpectations' label='Needs and Expectations of interested parties' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='riskandopportunity' label='Risk & Opportunity & Change Control' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='auditorcomments1' label='Auditor Comments (C/ NC/ O)' disabled={true} />
                                                                </div>

                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='leadership' label='5.1.1 Leadership & Commitment' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='customerfocus' label='5.1.2 Customer focus (statement of conformity)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='qualitypolicy' label='5.2 Quality policy (Establish, Implement, Maintain, communicated and understood)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='organizationalroles' label='5.3 Organizational roles, responsibilities and authorities' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='auditorcomments2' label='Auditor Comments (C/ NC/ O)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='customercommunication' label='8.2.1 Customer communication' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='determiningofrequirements' label='8.2.2 Determining of Requirements for products and services (contract review, Ensuring applicable Statutory & Regulatory requirements)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='reviewofrequirements' label='8.2.3 Review of the requirements for products and services (Documented Information for Result of review and any new requirements for product or services)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='changestorequirements' label='8.2.4 Changes to requirements for products and services. (Amendment of relevant documented information  & making the relevant persons aware of it )' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='customersatisfaction' label='9.1.2 Customer Satisfaction' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='resources' label='7.1 Resources' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='competence' label='7.2 Competence- (Determination of competency, ensuring persons are competent. Actions to acquire required competency, evidence of competency fulfillment.)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='awareness' label='7.3 Awareness - (Quality Policy, Objectives & Effectiveness of  QMS)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='internalandexternal' label='7.4 Internal & External Communication relevant to QMS - (what, who, when, whom, how)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='auditorcomment3' label='Auditor Comments (C/ NC/ O)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='environmentoperation' label='7.1.4 Environment for the operation of processes' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='controlofproduction' label='8.5.1 Control of production and service provision- (Availability of documented information for product characteristics, service provisions & results to be achieved' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='identification' label='8.5.2 Identification & Traceability' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='propertybelonging' label='8.5.3- Property belonging to customer or external providers' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='postdelivery' label='8.5.5- Post- delivery activities' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='controlofchanges' label='8.5.6- Control of changes' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='releaseofproduct' label='8.6 Release of product and services' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='controlofnonconforming' label='8.7 Control of non-conforming outputs' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='measurementtraceability' label='7.1.5.2 Measurement Traceability' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='auditorcomments4' label='Auditor Comments (C/ NC/ O)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='controlofexternally' label='8.4.1  Control of externally provided process, products and services' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='typeofextent' label='8.4.2- Type and extent of control, :  Addressed in documentation WP/N,  page 28 of 52' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='outsourceprocess' label='Outsource Process' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='informationforexternal' label='8.4.3- Information for external providers,' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='preservation' label='8.5.4 Preservation / Stores ' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='monitoring' label='9.1.1- Monitoring, Measurement analysis and evaluation' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='internalauditDes' label='9.2- Internal Audit' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='managementreview' label='9.3 Management Review' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='nonconformity' label='10.2- Non Conformity and Corrective action' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='continualimprovement' label='10.3- Continual Improvement' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='input' type="text" name='auditorcomments5' label='Auditor Comments (C/ NC/ O)' disabled={true} />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='obervations' label='Observations'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='opportunitiesforimprovment' label='Opportunities for Improvement'  />
                                                                </div>
                                                                <div className="form1RowDiv">
                                                                    <FormikControl control='textarea' type="text" name='positivefindingsSurveillance' label='Positive Findings' disabled={true} />
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <div className="card-footer">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Submit</button>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </Formik>
        </div>
    )
}

export default ObservationsurveillanceTwo